import React from 'react';
import { Hero } from './components/sections/Hero';
import { InvisiblePain } from './components/sections/InvisiblePain';
import { Mechanism } from './components/sections/Mechanism';
import { Founder } from './components/sections/Founder';
import { ValueStack } from './components/sections/ValueStack';
import { Objections } from './components/sections/Objections';
import { Testimonials } from './components/sections/Testimonials';
import { ScarcityClose } from './components/sections/ScarcityClose';
import { ReserveForm } from './components/sections/ReserveForm';
import { Faq } from './components/sections/Faq';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="w-full bg-white font-['Nunito_Sans',sans-serif] text-[#1A1A2E] antialiased" data-id="element-0" data-mp="2wjgp1comflds">
      <main data-id="element-1" data-mp="28tw5arkn8k3g">
        <Hero data-id="element-2" data-mp="28tmi1bqzgr1g" />
        <InvisiblePain data-id="element-3" data-mp="28t4l0cwhy8sh" />
        <Mechanism data-id="element-4" data-mp="28sbb5328r364" />
        <Founder data-id="element-5" data-mp="23vck4tdvjcc5" />
        <ValueStack data-id="element-6" data-mp="23vunsb2v8su3" />
        <Objections data-id="element-7" data-mp="23u9vks40xlze" />
        <Testimonials data-id="element-8" data-mp="23ut9lxqjzq85" />
        <ScarcityClose data-id="element-9" data-mp="23ti7e2craqj5" />
        <ReserveForm data-id="element-10" data-mp="3ikh8gaq64uzi" />
        <Faq data-id="element-11" data-mp="3iiwf2oflbi38" />
      </main>
      <Footer data-id="element-12" data-mp="3ijpcgysnsv8p" />
    </div>;
}